import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `microsoft_sql_server`,

  name: {
    [LOCALES.EN_US]: `Microsoft SQL Server`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.database],

  tags: [],
} as const satisfies TTerm
